import { QueryClient } from '@tanstack/react-query';

/**
 * Shared React Query client singleton.
 *
 * Lives in its own module (rather than main.tsx) so non-React code — e.g.
 * Zustand stores — can import it to invalidate cached queries after a
 * mutation, without pulling in main.tsx's render side effects.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});
